module.exports = __webpack_public_path__ + "img/flfw_30.27dc1eb2.png";